import BaseController from "confinus_ui/base_controller";

/**
 * Loading overlay controller for the messaging interface.
 * Hides the loading overlay once Rails UJS is fully loaded and ready.
 * This prevents users from interacting with links/forms before JavaScript is ready,
 * which would cause GET requests instead of proper DELETE/POST/etc requests.
 */
export default class extends BaseController {
  connect() {
    // Wait for DOMContentLoaded to ensure Rails UJS is initialized
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => this.hideOverlay());
    } else {
      // DOM already loaded, hide immediately
      this.hideOverlay();
    }
  }

  private hideOverlay() {
    // Small delay to ensure Rails UJS event handlers are attached
    setTimeout(() => {
      this.element.classList.add("opacity-0", "pointer-events-none");

      // Remove from DOM after fade animation
      setTimeout(() => {
        this.element.remove();
      }, 300);
    }, 100);
  }
}
